const ALT_TEXT_PREFIX = 'gatsby-theme-lemonade';
const DEFAULT_IMAGE_NAME = 'gatsby-icon';
const DEFAULT_IMAGE = 'gatsby-icon.png';

module.exports = {
    ALT_TEXT_PREFIX,
    DEFAULT_IMAGE,
    DEFAULT_IMAGE_NAME,
};
